import React from 'react';
import { ErrorMessage } from '@atlaskit/form';
import type { ErrorType } from './types';

export default function Error({ error }: ErrorType) {
	return error !== undefined && !!error ? <ErrorMessage>{error}</ErrorMessage> : null;
}
